import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
          <i className="ri-emotion-sad-line text-4xl text-foreground-300"></i>
        </div>
        <h1 className="font-heading text-4xl font-bold text-foreground-950 mb-2">404</h1>
        <p className="text-sm text-foreground-500 mb-8">抱歉，您访问的页面不存在</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}